import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
	getFetchStateDefaultValue,
	handleFailureCase,
	handleRequestCase,
	handleSuccessCase,
} from "State/Utils";
import {
	getCutoffsAdvisorOverviewsPdfsAvailableYears,
	GetCutoffAdvisorOverviewsAvailableYearsQueryResult,
} from "Api/Api";

export const getCutoffAdvisorOverviewsAvailableYearsAsync = createAsyncAction(
	"@cutoff/GET_AVAILABLE_YEARS_ADVISOR_OVERVIEWS_REQUEST",
	"@cutoff/GET_AVAILABLE_YEARS_ADVISOR_OVERVIEWS_RESPONSE",
	"@cutoff/GET_AVAILABLE_YEARS_ADVISOR_OVERVIEWS_FAILURE",
)<void, GetCutoffAdvisorOverviewsAvailableYearsQueryResult, Error>();

function* getCutoffAdvisorOverviewsAvailableYears(): Generator {
	try {
		const { data, error, status } = yield* call(
			getCutoffsAdvisorOverviewsPdfsAvailableYears,
		);

		if (status === 200) {
			yield put(getCutoffAdvisorOverviewsAvailableYearsAsync.success(data));
			return;
		}

		yield put(
			getCutoffAdvisorOverviewsAvailableYearsAsync.failure(
				mapAPIErrorResponse(error ?? data),
			),
		);
	} catch (err) {
		yield put(getCutoffAdvisorOverviewsAvailableYearsAsync.failure(err as Error));
	}
}

export function* getCutoffAdvisorOverviewsAvailableYearsSaga() {
	yield takeLatest(
		getType(getCutoffAdvisorOverviewsAvailableYearsAsync.request),
		getCutoffAdvisorOverviewsAvailableYears,
	);
}

export const getCutoffAdvisorOverviewsAvailableYearsSlice = createSlice({
	initialState:
		getFetchStateDefaultValue<GetCutoffAdvisorOverviewsAvailableYearsQueryResult>(
			false,
		),
	name: "@cutoff/getCutoffAdvisorOverviewsAvailableYears",
	reducers: {},
	extraReducers: builder => {
		handleRequestCase(getCutoffAdvisorOverviewsAvailableYearsAsync, builder);
		handleSuccessCase(getCutoffAdvisorOverviewsAvailableYearsAsync, builder);
		handleFailureCase(getCutoffAdvisorOverviewsAvailableYearsAsync, builder);
	},
});
